import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BookOpen, RefreshCw, Lightbulb } from "lucide-react";
import { SPEND, LIFE } from "@/data/quotes";
import { MONEY_QUOTES } from "@/data/moneyQuotes";
import { useData } from "@/context/DataContext";
import { t, getLang } from "@/lib/i18n";

const ISL = [...SPEND, ...LIFE];
const pick = (n, not) => { let k; do { k = Math.floor(Math.random() * n); } while (k === not && n > 1); return k; };

export default function QuoteCard() {
  const { db } = useData();
  const muslim = db.settings.prefs.faith !== "other";
  const all = muslim ? ISL : MONEY_QUOTES;
  const [k, setK] = useState(() => pick(all.length, -1));
  const q = all[k % all.length];
  const bn = getLang() === "bn";
  const quoteText = bn ? (q[3] || q[0]) : q[0];
  const quoteSource = bn ? q[1].replace(/^Quran /, "সূরা/আয়াত ").replace(/Sahih al-Bukhari/g, "সহিহ বুখারি").replace(/Sahih Muslim/g, "সহিহ মুসলিম").replace(/Jami at-Tirmidhi/g, "জামে তিরমিজি").replace(/ · sahih/g, " · সহিহ") : q[1];
  const head = muslim ? (q[2] === "Q" ? t("From the Quran") : t("From the Hadith")) : t("Money wisdom");
  const Icon = muslim ? BookOpen : Lightbulb;
  return (
    <button onClick={() => setK(pick(all.length, k))} className="mm-card mm-quote mm-rise relative block w-full overflow-hidden text-left" data-testid="islamic-quote-card">
      <div className="mm-hero-sheen" aria-hidden="true" />
      <div className="relative z-10 mb-3 flex items-center justify-between text-xs font-semibold uppercase tracking-[0.18em] text-[var(--ac)]">
        <span className="flex items-center gap-2" data-testid="quote-heading"><Icon className="h-4 w-4" /> {head}</span>
        <RefreshCw className="h-4 w-4 opacity-60" data-testid="islamic-quote-rotate-button" />
      </div>
      <div className="relative z-10"><AnimatePresence mode="wait">
        <motion.div key={`${muslim}-${k}-${bn}`} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.25 }}>
          <p className="text-[17px] font-medium leading-relaxed" style={{ fontFamily: bn ? "var(--bengali), sans-serif" : "Fraunces, serif" }} data-testid="islamic-quote-text">“{quoteText}”</p>
          <p className="mt-3 text-sm font-semibold text-[var(--mu)]" data-testid="quote-source">— {quoteSource}</p>
        </motion.div>
      </AnimatePresence></div>
      <p className="relative z-10 mt-3 text-[11px] text-[var(--mu)]">{muslim ? `${t("English meaning; translation wording can vary.")} ` : ""}{t("Tap for another.")}</p>
    </button>
  );
}
